import { action, flow, makeObservable, observable } from 'mobx';
import { GlobalStore, GridStore } from '@roc/feature-app-core';
import { BackgroundReviewFormStore } from './backgroundReviewFormStore';
import { BackgroundItemStore } from './backgroundItemStore';

export class CreditReviewStore {
  globalStore: GlobalStore;
  creditReviewFormStore: BackgroundReviewFormStore;
  creditItemStore: BackgroundItemStore;

  constructor(globalStore: GlobalStore) {
    this.globalStore = globalStore;
    this.creditReviewFormStore = new BackgroundReviewFormStore(
      globalStore
    );
    this.creditItemStore = new BackgroundItemStore(
      globalStore,
      this.creditReviewFormStore
    );
    makeObservable(this, {

    });
  }
};